import { filter } from "rxjs/operators";
import { Alert, EventEmailTemplatesDocument, FetchAlertsDocument } from "src/generated-gql/graphql";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import {
  SharedModule,
  TypedBaseListComponent,
  ModalService,
} from "@bb-vendure/admin-ui/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./event-email-template-list.component.html",
  standalone: true,
  imports: [SharedModule],
})
export default class EventEmailTemplateListComponent extends TypedBaseListComponent<
  typeof EventEmailTemplatesDocument,
  "eventEmailTemplates"
> {
  constructor(private modalService: ModalService) {
    super();
    super.configure({
      document: EventEmailTemplatesDocument,
      getItems: (data) => data.eventEmailTemplates,
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: this.filters.createFilterInput(),
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .connectToRoute(this.route);
    
  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .connectToRoute(this.route);
}

